import classes from './HeaderItem.module.css';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import SearchIcon from '../SearchIcon/SearchIcon';
import {styled} from '@mui/material/styles';

const HeaderItem = ({icon, iconSettings, containerCss="", e=()=>{}}) => {
	const Phone = styled(PhoneIcon)(() => iconSettings);
	const Mail = styled(EmailIcon)(() => iconSettings);

	const icons = {
		'phone': <Phone/>, 
		'email': <Mail/>,
		'search': <SearchIcon styles={iconSettings}/>
	};

	return (
		<div className={`${classes.container} ${containerCss}`} onClick={()=>{e()}}>
			{icons[icon]}
		</div>
	);
};

export default HeaderItem;